import { ELanguageType } from '../enums';

export const isHebrewText = (text: string, strict: boolean = false): boolean => {
  const hebrewPattern = strict
    ? new RegExp(/^[\u0590-\u05FF ~,.:;/''"?!^@&#$%*()_`=+{}|[\]<>\d-]+$/i)
    : new RegExp(/[\u0590-\u05FF]/);

  return hebrewPattern.test(text);
};

export const getTextLanguageByText = (text: string, strict: boolean = false): ELanguageType =>
  isHebrewText(text, strict) ? ELanguageType.HEBREW : ELanguageType.ENGLISH;
